export function collectFontWeight(fontArray = []) {
  const weightArr = fontArray.map(font => font.weight).filter(font => font !== '');
  // For fonts.googleapis.com the weights need to be in order from lowest first
  weightArr.sort((a, b) => a - b);
  return [...new Set(weightArr)].toString().replaceAll(',', ';');
}

// Only way currently to import artemis fonts.
export default function getFonts(urlArray) {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = `${urlArray[0]?.url}:wght@${collectFontWeight(urlArray)}`;
  document.getElementsByTagName('head')[0].appendChild(link);
}
